<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-body card-body-custom">
        <b-row>
          <!-- <iframe
            :src="mData.dataDefault.links"
            width="100%"
            frameborder="0"
            style="padding: 0 20px; z-index: 10; height: calc(100vh - 113px)"
          ></iframe> -->
          <a
            :href="mData.dataDefault.links"
            target="_blank"
            rel="noopener noreferrer"
          ></a>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
// import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import UserSVHTTApi from "../../../moduleApi/UserSVHTTApi";
import ProvinceApi from "../../../moduleApi/ProvinceApi";

export default {
  data() {
    return {
      mData: {
        moduleName: "TrangDieuHanh",
        dataDefault: {
          links: "",
          iframe: {
            src: "",
            style: null,
            wrapperStyle: null,
          },
        },
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
      },
    };
  },
  methods: {
    async fn_getDataById() {
      const res = await UserSVHTTApi.findById(this.mData.currentUser.id);
      const provinceRes = await ProvinceApi.findById(res.result.province_id);
      let maTinhArr = MethodService.changeAlias(provinceRes.result.name).split(
        " "
      );
      const maTinh = maTinhArr.join("");
      console.log("maTinh", maTinh);
      // this.mData.dataDefault.links = `https://dash.vietnamtourism.gov.vn/superset/dashboard/dashboard8/?preselect_filters=${encodeURIComponent(`{"52":{"__time_range":"Last 365 days"},"67":{"ma_tinh":"${maTinh}"}}`)}`;
      this.mData.dataDefault.links = "https://baocao.trangvangdulichvietnam.vn";
      let ele = document.createElement("a");
      ele.setAttribute("href", this.mData.dataDefault.links);
      ele.setAttribute("target", "_blank");
      ele.click();
      this.$router.push({
        name: "Admin-Home",
      });
      // debugger;
    },
  },
  created: function () {
    this.fn_getDataById();
  },
  mounted: function () {},
};
</script>
<style scoped>
.card {
  position: relative;
  margin-bottom: 0;
}
.card-body-custom {
  padding: 0;
}
.animated {
  margin-left: -5px;
  margin-right: -5px;
}
</style>
